import {CaseStyle} from "kryo";
import {$Uint32} from "kryo/integer";
import {RecordIoType, RecordType} from "kryo/record";

import {$RunIdRef, RunIdRef} from "./run-id-ref.mjs";

export interface BestLevelRun {
  level: number;
  run: RunIdRef;
}

export const $BestLevelRun: RecordIoType<BestLevelRun> = new RecordType<BestLevelRun>({
  properties: {
    level: {type: $Uint32},
    run: {type: $RunIdRef},
  },
  changeCase: CaseStyle.SnakeCase,
});
